export default __webpack_public_path__ + "static/media/floatingButton02.ba138e32.png";